const linkLandingPagesValidationIT = {
    "add": {
        "title": {
            "required": "Il titolo è obbligatorio",
            "length": "Il titolo non può essere più lungo di 32 caratteri"
        },
        "short_description": {
            "length": "La descrizione non può essere più lunga di 80 caratteri."
        },
        "back_url": {
            "required": "L'URL di ritorno è obbligatorio",
            "length": "L'URL di ritorno non può essere più lungo di 10 caratteri",
            "unique": "Ops! Questo URL di ritorno è già associato a un'altra pagina di destinazione. Si prega di provare un altro URL di ritorno.",
            "available": "L'URL di ritorno è disponibile",
            "invalid": "L'URL di ritorno non è valido"
        },
        "logo": {
            "required": "Il logo è obbligatorio",
            "dimensions": "Le dimensioni del logo devono essere almeno 500 X 500 px e l'immagine deve avere un rapporto di aspetto 1:1, formati supportati JPG/JPEG/PNG.",
            "choose": "Si prega di scegliere un'immagine",
            "file": "Si prega di caricare formati JPG o PNG, risoluzione minima 500 X 500 px e immagine con rapporto di aspetto 1:1. Dimensione massima 2MB"
        },
        "background_image": {
            "dimensions": "Le dimensioni dell'immagine di sfondo devono essere almeno 1000 X 1000 px e l'immagine deve avere un rapporto di aspetto 1:1, formati supportati JPG/JPEG/PNG.",
            "choose": "Si prega di scegliere un'immagine",
            "file": "Si prega di caricare formati JPG o PNG, risoluzione minima 1000 X 1000 px e immagine con rapporto di aspetto 1:1. Dimensione massima 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di Facebook non valido"
        },
        "social_link_destination_url_instagram": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di Instagram non valido"
        },
        "social_link_destination_url_twitter": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di Twitter non valido"
        },
        "social_link_destination_url_youtube": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di Youtube non valido"
        },
        "social_link_destination_url_tiktok": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di TikTok non valido"
        },
        "social_link_destination_url_linkedin": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di LinkedIn non valido"
        },
        "social_link_destination_url_other": {
            "regexp": "URL non valido"
        },
        "featured_link_title": {
            "required": "L'etichetta è obbligatoria",
            "length": "L'etichetta non può superare i 100 caratteri"
        },
        "featured_link_destination_url": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido"
        }
    },
    "update": {
        "title": {
            "required": "Il titolo è obbligatorio",
            "length": "Il titolo non può essere più lungo di 32 caratteri"
        },
        "short_description": {
            "length": "La descrizione non può essere più lunga di 80 caratteri."
        },
        "back_url": {
            "required": "L'URL di ritorno è obbligatorio",
            "length": "L'URL di ritorno non può essere più lungo di 10 caratteri",
            "unique": "Ops! Questo URL di ritorno è già associato a un'altra pagina di destinazione. Si prega di provare un altro URL di ritorno.",
            "available": "L'URL di ritorno è disponibile",
            "invalid": "L'URL di ritorno non è valido"
        },
        "logo": {
            "required": "Il logo è obbligatorio",
            "dimensions": "Le dimensioni del logo devono essere almeno 500 X 500 px e l'immagine deve avere un rapporto di aspetto 1:1, formati supportati JPG/JPEG/PNG.",
            "choose": "Si prega di scegliere un'immagine",
            "file": "Si prega di caricare formati JPG o PNG, risoluzione minima 500 X 500 px e immagine con rapporto di aspetto 1:1. Dimensione massima 2MB"
        },
        "background_image": {
            "dimensions": "Le dimensioni dell'immagine di sfondo devono essere almeno 1000 X 1000 px e l'immagine deve avere un rapporto di aspetto 1:1, formati supportati JPG/JPEG/PNG.",
            "choose": "Si prega di scegliere un'immagine",
            "file": "Si prega di caricare formati JPG o PNG, risoluzione minima 1000 X 1000 px e immagine con rapporto di aspetto 1:1. Dimensione massima 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di Facebook non valido"
        },
        "social_link_destination_url_instagram": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di Instagram non valido"
        },
        "social_link_destination_url_twitter": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di Twitter non valido"
        },
        "social_link_destination_url_youtube": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di Youtube non valido"
        },
        "social_link_destination_url_tiktok": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di TikTok non valido"
        },
        "social_link_destination_url_linkedin": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido",
            "invalid": "URL di LinkedIn non valido"
        },
        "social_link_destination_url_other": {
            "regexp": "URL non valido"
        },
        "featured_link_title": {
            "required": "L'etichetta è obbligatoria",
            "length": "L'etichetta non può superare i 100 caratteri"
        },
        "featured_link_destination_url": {
            "required": "L'URL di destinazione è obbligatorio",
            "regexp": "URL non valido"
        }
    }
};

export default linkLandingPagesValidationIT;